import { render, staticRenderFns } from "./CompanySummarySectors.vue?vue&type=template&id=cec5c858&"
import script from "./CompanySummarySectors.vue?vue&type=script&lang=js&"
export * from "./CompanySummarySectors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports